<template>
  <div>
    <positions :isreadonly='false'></positions>
  </div>
</template>
 
<script>
import positions from './modules/positions'
export default {
  components: {
    positions
  },
  props: {},
  data () {
    return {

    };
  },
  created () { },
  mounted () { },
  methods: {

  },
  computed: {},
  watch: {},
}; 
</script>

<style scoped>
</style>
